<div class="subBlockContainer componentContainer">
  <div class="subBlockContent componentContent">
   
    <div class="inner-subBlock-wrapper">
      <div class="page-title-wrapper">
        <div class="page-title-position">
          {{title}} - {{reportType}}
        </div>
        <i class="material-icons pullfloat-right" (click)="close()">close</i>
      </div>
      <div class="top-divider"></div>
      <div class="inner-subBlock-wrapper">
        <div class="subContainer">
            <!-- Title Entry -->
            <div class="input-control text">
            <input id="reportNameTxtBox" class="reportNameTxtBox"[(ngModel)]="reportName" type="text" placeholder="REPORT NAME"/>
            </div>
            <!-- Column choices -->
            <div class="columns full">
            <div class="column wide">
                <div class="listContainer">
                    <div class="unsortable-container">
                        <div class="unsortable-header"><label class="unsortable-name">AVAILABLE FIELDS</label></div>
                        <ul class="unsortable-list">
                            <li class="unsortable-list-element"*ngFor="let col of availableCols" (click)="makeSelected($event)">
                                <div class="unsortable-list-item">{{col}}</div>
                            </li>
                        </ul>
                    </div>   
                </div>
            </div>
            <div class="column slim">
                <button title="ADD ALL" class="buttonSelection button button-red button-small" (click)='addAllToSelected()'>>></button>
                <button title="ADD" class="buttonSelection button button-red button-small" (click)='addToSelected()'>></button>
                <button title="REMOVE" class="buttonSelection button button-red button-small" (click) ='removeFromSelected()'><</button>
                <button title="REMOVE ALL" class="buttonSelection button button-red button-small" (click) ='removeAllFromSelected()'><<</button>
            </div>
            <div class="column wide">
                <div class="listContainer">
                    <!-- <ngx-sortable [items]="selectedCols" [name]="'SELECTED FIELDS'" [listStyle]="listStyle" (listSorted)="listSorted($event)">  
                    <ng-template let-selected>
                        <div class="sortable-list-item">
                        {{selected}}<span id="dragImg" class="fas fa-align-justify" style="margin-right: 10px; float: right;"></span>
                        </div>
                    </ng-template>
                </ngx-sortable>            -->
                </div>
            </div>
            </div>
        </div>
        <!-- Next and Submit buttons -->
        <div>
          <button id="nextButton" class="button button-red button-small" (click)="openFilterPage()">Next</button>
        </div>
      </div>
    </div>
    <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
</div>
<!-- <div class="component-loader"> -->
  <ng-template #filters></ng-template>
<!-- </div> -->

